import React, { useState } from 'react';
import { 
  Box, 
  Switch, 
  FormControlLabel, 
  Paper, 
  Typography,
  IconButton,
  Tooltip,
  ButtonGroup,
  Button
} from '@material-ui/core';
import { Palette, Dashboard, ViewModule, ViewComfy } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import CompanyOverview from './CompanyOverview';
import ModernCompanyOverview from './ModernCompanyOverview';
import CompanyAdminOverview from './CompanyAdminOverview';

const useStyles = makeStyles((theme) => ({
  switchContainer: {
    position: 'fixed',
    top: 20,
    right: 20,
    zIndex: 1000,
    background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: 12,
    padding: theme.spacing(1.5),
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  modernButton: {
    borderRadius: 6,
    textTransform: 'none',
    fontWeight: 600,
    minWidth: 80,
    fontSize: '0.75rem',
  },
}));

const CompanyOverviewSwitch = (props) => {
  const classes = useStyles();
  const [viewMode, setViewMode] = useState('modern'); // 'classic' or 'modern'

  const handleViewChange = (newViewMode) => {
    setViewMode(newViewMode);
  };

  return (
    <Box>
      {/* Render appropriate view */}
      {viewMode === 'modern' ? (
        <CompanyAdminOverview 
          {...props} 
          companyBoxStats={props.companyBoxStats}
          companyAdminData={props.companyAdminData}
          trainingAdminData={props.trainingAdminData}
          trainingData={props.trainingData}
          threatModel={props.threatModel}
          clickStats={props.userClickActivity}
          userOverviewData={props.userClickOverviewData}
          viewMode={viewMode}
          onViewModeChange={handleViewChange}
        />
      ) : (
        <CompanyOverview 
          {...props}
          viewMode={viewMode}
          onViewModeChange={handleViewChange}
        />
      )}
    </Box>
  );
};

export default CompanyOverviewSwitch;